{
  "app": {
    "title": "Fatturazione",
    "close_button": "Chiudi",
    "loading": "Caricamento..."
  },
  "orders_dashboard": {
    "title": "Ordini",
    "filter_all": "Tutti",
    "filter_unassigned": "Non assegnato",
    "filter_expiring": "In scadenza",
    "filter_undeployed": "Disponibile per il deployment",
    "filter_canActivate": "Disponibile per l'attivazione",
    "search_orders": "Cerca ordini"
  },
  "orders_list": {
    "subscriptionExpiry": "SCADENZA ABBONAMENTO",
    "end_of_orders_list": "fine dell'elenco ordini",
    "orderDate": "DATA ORDINE",
    "orderNumber": "NUMERO ORDINE",
    "subscriptionNumber": "NUMERO ABBONAMENTO",
    "accountName": "ACCOUNT ASSEGNATO",
    "unassigned": "Non assegnato",
    "unavailable": "Non disponibile",
    "expiring": "IN SCADENZA",
    "assign": "ASSEGNA",
    "expired": "SCADUTO",
    "perpetual": "PERPETUO",
    "pending": "ATTIVAZIONE IN ATTESA",
    "error_retrieving_orders": "Si è verificato un errore durante il recupero degli ordini.",
    "no_orders_found": "Nessun ordine trovato.",
    "deploy": "Distribuire",
    "activate": "Attivare"
  },
  "order_details": {
    "deploy_button": "Distribuire",
    "activate_button": "Attivare",
    "assign_button": "Assegna",
    "order_number": "N. ordine",
    "tracking_number": "ID di Tracciamento",
    "subscription_number": "N. abbonamento",
    "see_additional_details": "Visualizza dettagli di tracciamento aggiuntivi",
    "hide_additional_details": "Riduci altri dettagli di tracciamento aggiuntivi",
    "po_number": "Numero ordine di acquisto rivenditore",
    "reseller_SAP_Id": "ID SAP rivenditore",
    "sapOrderId": "ID ordine SAP",
    "order_assigned_to": "Ordine assegnato a",
    "start_date": "Data di inizio",
    "term": "Termine",
    "please_pick_acct_msg": "Non siamo in grado di abbinare questo ordine perciò selezionare manualmente un account a cui applicarlo.",
    "company": "Azienda",
    "create_new_account": "Crea nuovo account",
    "order_expiry_time": "L'ORDINE SCADRÀ ENTRO {{numdays}} GIORNI",
    "licenses": "Licenze",
    "license": "Licenza",
    "customerSapId": "ID SAP cliente",
    "customerPONumber": "Numero ordine di acquisto cliente",
    "search_companies": "Cerca aziende",
    "month": "Mese",
    "year": "Anno",
    "day": "Giorno",
    "unknown": "Sconosciuto",
    "assigning_account_to_order": "Assegnazione ordine ad account in corso...",
    "deploying_order": "Ordine in fase di distribuzione...",
    "activating_order": "Ordine in fase di attivazione...",
    "error_assigning_order": "Si è verificato un errore durante l'assegnazione dell'ordine all'account.",
    "error_deploying_order": "C'è stato un errore nel distribuire l'ordine.",
    "error_activating_order": "C'è stato un errore nell'attivare l'ordine.",
    "cannot_comm_parent": "Non possiamo reindirizzarti al modulo appropriato, puoi creare l'account dall'app Accounts.",
    "no_results_found": "Nessun risultato trovato",
    "existing-subscription": "Assegnazione fallita: questa azienda ha già un ordine.",
    "0001": "Licenze insufficienti. Il numero di licenze gratuite assegnate ({free}) supera il numero di licenze ({paid}) nell'ordine a pagamento.",
    "restricted_view_warning": "Funzionalità disabilitate. Il tuo accesso è limitato."
  },
  "order_complete": {
    "go-to-account-integrations": "Vai a integrazioni account",
    "go-to-account": "Vai al conto",
    "activate-order": "Attivare l'ordine",
    "order-added": "Ordine aggiunto!",
    "order-deployed": "Ordine distribuito!",
    "order-activated": "Ordine attivato!",
    "enable-integration": "Solo una nota, per il funzionamento degli elementi in questo ordine è necessario configurare e abilitare un'integrazione",
    "activate-order-instructions": "Solo una nota: questo ordine deve essere attivato per funzionare."
  },
  "errors": {
    "504-general-message": "La soluzione è occupata o irraggiungibile. Per favore riprova.",
    "couldnt-find-order": "Non abbiamo trovato l'ordine nell'elenco. Ricarica la pagina, per favore."
  }
}